var _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#272D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACf0lEQVR4nO3cwW7TQBSF4b8tTwKiwIqKUoWXRqqoENmVF4JGqqCFLsJiuJCkTeKxx7lzx+eTsuvizjmJnXocg4iIiIiIiIiIiIhIOEfeA4ys2vWdAXPgDvgFXAGvXScq6w1wCSxIa5wDb10nWnEG3ALLjdcNMHOcq5QZaS2b67ulkhLmPB7OXgtilzAjrWHb+r74jZYckz6S2waMXMK+8JektbufF36ye8iIJXQJfwn88Bpw1SX7B41UQtfwl8BHpxnXvODpk1TEEnLCvwGe+4z52DvgG91L+OAz5k7nwHcCv5EilxA+fBOxhGbCN5FKaC58E6GEZsM3NZfQfPimxhImE76pqYTJhW9qKGGy4RvPEiYfvvEoQeFvOGQJCn+LQ5Sg8PcYswSF39EYJSj8TCVLUPg9lShB4Q80pASFX0ifEhR+YTn7sovMv1X4HeV8EhT+SEqVoPAHGFqCwi+gbwkKv6DcEsKEf+w9QEdH5N8E637TbCtyvufv+mdNeugbvkooYGj4KmGAUuGrhB50KcJRnwtrNdzy0oQhVzVVwkAlLimrhJ5KXs9XCZnG2ExRCR2NuZOlEvY4xDaiStjikHu4KmGDxwa6SvjL8+6FyZdQw60jky2hhvDN5EqoKXwzmRJqDN80X0LN4ZtmS4gQvmmuhEjhm2ZKiBi+CV9C5PBN2BJeMd1Hlp36jLnuM22Eb3JKuHKa8Z8T0qOKWwnfdD0c3ZMycPMMeKCt8E2XEn7jXADAV9oL3+w7HF37jfbfBU8/vrj1h3ffAe8d51pzQXo3PJCOi5+Al64TlXVKOuHek9Z4TUXhrzohzm8O+jimgmO+iIiIiIiIiIiIiEimP4bQBU74wKQBAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.4df978f14c50314383bf18205c978365.svg";
export { ForwardRef as ReactComponent };